var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.49414 5.5L19.0001 5.5V17C19.5306 17 20.0393 16.7893 20.4144 16.4142C20.7894 16.0391 21.0001 15.5304 21.0001 15V5.5C21.0001 4.96957 20.7894 4.46086 20.4144 4.08579C20.0393 3.71071 19.5306 3.5 19.0001 3.5L9.49414 3.5C8.96371 3.5 8.455 3.71071 8.07993 4.08579C7.70485 4.46086 7.49414 4.96957 7.49414 5.5ZM5.154 7.5C3.964 7.5 3 8.464 3 9.654L3 19.346C3 19.9173 3.22694 20.4652 3.63089 20.8691C4.03485 21.2731 4.58272 21.5 5.154 21.5H14.846C16.036 21.5 17 20.536 17 19.346V9.654C17 8.464 16.036 7.5 14.846 7.5L5.154 7.5ZM15 9.5L5 9.5L5 19.5H15L15 9.5Z","fill":"#E8EFFF"})));
}

CopyIcon.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
